// Components
import { Box, Button, ButtonGroup, Icon } from '@zillow/constellation-10';
import { IconPiggyBankFilled } from '@zillow/constellation-icons';

import ConnectedModuleCard from '../../../ConnectedModuleCard';
import InlineStyledText from '../InlineStyledText';

import {
  EmptyStateBodyText,
  EmptyStateTitleText,
  StyledEmptyStateContainer,
  StyledIconContainer,
} from '../../../../styles';

type StyledText = {
  text: string;
  url?: string;
  styling?: string;
};

type Props = {
  title: string;
  description: string;
  ctaLink: {
    text: string;
    url: string;
  };
  ctaPrimaryButton: {
    text: string;
    url: string;
  };
  disclaimer?: Array<StyledText>;
};

const EmptyPaymentsCard = ({ title, description, ctaLink, ctaPrimaryButton, disclaimer }: Props) => {
  const getDisclaimerText = (styledTextList: Array<StyledText>) =>
    styledTextList.map((styledText) => ({
      styling: 'legal',
      ...styledText,
    }));

  return (
    <ConnectedModuleCard data-testid="empty-payments-card">
      <StyledEmptyStateContainer>
        <StyledIconContainer aria-hidden="true">
          <Icon size="md" css={{ color: 'icon.subtle' }} render={<IconPiggyBankFilled />} />
        </StyledIconContainer>

        <EmptyStateTitleText asChild>
          <h4>{title}</h4>
        </EmptyStateTitleText>

        <EmptyStateBodyText asChild>
          <p>{description}</p>
        </EmptyStateBodyText>

        <ButtonGroup
          aria-label="payment actions"
          orientation={{ base: 'vertical', md: 'horizontal' }}
          reverse={{ base: true, md: false }}
        >
          {ctaLink.text && ctaLink.url && (
            <Button asChild tone="brand" emphasis="outlined" data-testid="empty-payments-card-default-button">
              <a href={ctaLink.url}>{ctaLink.text}</a>
            </Button>
          )}

          <Button asChild tone="brand" emphasis="filled">
            <a href={ctaPrimaryButton.url}>{ctaPrimaryButton.text}</a>
          </Button>
        </ButtonGroup>

        {disclaimer && (
          <>
            <Box css={{ marginBottom: 'default' }} />
            <InlineStyledText styledTextList={getDisclaimerText(disclaimer)} />
          </>
        )}
      </StyledEmptyStateContainer>
    </ConnectedModuleCard>
  );
};

export default EmptyPaymentsCard;
